<template>
  <section>
    <div v-if="loading">

      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <h2 class="intro-y text-lg font-medium mr-auto mt-8">
            Equipos ({{ teams.length }})
          </h2>
        </div>
        <div class="w-full sm:w-auto flex">
            <a data-target="#team" data-toggle="modal" class="button text-white bg-theme-1 shadow-md mr-2">Crear Equipo</a>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              Editar Equipo
          </h2>
        </div>
        <form  @submit.prevent="updateTeam">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-6 sm:col-span-6">
              <label>Nombre:</label>
              <input v-on:input="updateValue('name',$event)" type="text" class="input w-full border mt-2 flex-1"
                :value="team.name" required>
          </div>
          <div class="col-span-6 sm:col-span-6">
              <label>Estado</label>
              <select class="input w-full border mt-2" v-on:input="updateValue('status',$event)"
                  :value="team.status" required>
                  <option disabled>Seleccione el usuario</option>
                  <option value="0">Inactivo</option>
                  <option value="1">Activo</option>
              </select>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
            <button type="button" v-on:click="closeEditTeam()" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
            <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Modificar</button>
        </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- List -->
      <div class="intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5">
          <div class="intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2" v-for="team in teams">
            <div class="file box rounded-md px-5 pt-8 pb-5 px-3 sm:px-5 relative zoom-in">
                <a href="#" class="w-3/5 file__icon file__icon--directory mx-auto">
                    <div class="file__icon__file-name"></div>
                </a>
                <a href="#" class="block font-medium mt-4 text-center truncate">{{team.name}}</a>
                <div class="text-gray-600 text-xs text-center">{{team.status === 0 ? 'Inactivo' : 'Activo'}}</div>
                <div class="absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto">
                    <a class="dropdown-toggle w-5 h-5 block" href="javascript:;">
                      <app-icon v-bind:name="'more-vertical'" v-bind:classname="'w-5 h-5 text-gray-500'"></app-icon>
                    </a>
                    <div class="dropdown-box mt-5 absolute w-40 top-0 right-0 z-10">
                        <div class="dropdown-box__content box p-2">
                            <a v-on:click="editTeam(team)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                              <app-icon v-bind:name="'edit'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon> Editar
                            </a>
                            <a v-on:click="removeTeam(team)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                              <app-icon v-bind:name="'trash'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon> Eliminar
                            </a>
                            <router-link :to="'/admin/users?team='+team.id" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                              <app-icon v-bind:name="'users'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon> Miembros
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <!-- END: List -->

    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>

    <!-- Modal -->
    <div class="modal" id="team">
      <div class="modal__content modal__content--sm">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              Crear Equipo
          </h2>
        </div>
        <form  @submit.prevent="createTeam">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-12 sm:col-span-12">
              <label>Nombre:</label>
              <input  type="text" class="input w-full border mt-2 flex-1" v-model="team.name" required>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
            <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
            <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Crear</button>
        </div>
        </form>
      </div>
    </div>
    <!-- Modal End -->

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListTeam',
  data () {
    return {
      loading: false,
      boxedit: false,
      team: {
        name: '',
        status: '',
        entity: 'team'
      },
      team_current: {}
    }
  },
  computed: {
    ...mapGetters({
      teams: 'getTeams'
    })
  },
  beforeMount () {
    //SEND ENTITY AND MUTATION
    this.getAll('team')
    .then(() => {
      this.loading = true
    })
  },
  methods: {
    createTeam () {
      var vm = this
      window.$('#create').button('loading')
      vm.store(vm.team).then(item => {
        window.$('#team').modal('hide')
        vm.team = { name: '', entity: 'team' }
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/teams')
      })
      .catch(error => {
        window.$('#create').button('reset')
        vm.team = { name: '', entity: 'team' }
      })
    },
    removeTeam: function (value) {
      var vm = this
      vm.form = {
        id : value.id,
        entity : 'team'
      }
      vm.loading = false
      vm.remove(vm.form).then(item => {
        vm.loading = true
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/teams')
      })
      .catch(message => {
        vm.loading = true
      })
    },
    editTeam: function (value) {
      this.boxedit = true
      this.team = value
    },
    closeEditTeam: function () {
      this.boxedit = false
      this.team_current = {}
    },
    updateTeam: function (value) {
      var vm = this
      vm.form = {
        id : vm.team.id,
        entity : 'team',
        name: vm.team_current.name,
        status: vm.team_current.status
      }
      vm.loading = false
      vm.update(vm.form).then(item => {
        vm.loading = true
        vm.boxedit = false
        vm.team = { name: '', entity: 'team' }
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/teams')
      })
      .catch(message => {
        vm.loading = true
      })
    },
    updateValue (attribute, e) {
      this.team_current[attribute] = e.target.value
    },
    ...mapActions([
      'getAll',
      'remove',
      'store',
      'update'
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading
  }
}
</script>



// WEBPACK FOOTER //
// ListTeam.vue?ea3a5d6c